import { useGetOrganizationRulesQuery } from '@generated/graphql';
import { useOrganizationContext } from '@navigation/OrganizationContext';
import { useEditRulesModal } from './EditRulesModal';
import { RulesCard, type RulesCardProps } from './RulesCard';

type OrganizationRulesCardProps = Omit<
  RulesCardProps,
  'rules' | 'source' | 'onEdit' | 'editDisabled'
>;

export const OrganizationRulesCard = (props: OrganizationRulesCardProps) => {
  const { organizationId, isAdmin } = useOrganizationContext();
  const { data: organizationRulesData } = useGetOrganizationRulesQuery({
    variables: { organizationId },
    skip: !organizationId,
  });
  const organizationRules = organizationRulesData?.getOrganizationRules || '';

  const { showEditRulesModal } = useEditRulesModal({
    componentProps: {
      organizationId,
      reloadKey: 'organization-edit-rules',
    },
    modalProps: {
      title: 'Edit organization rules',
    },
  });
  const handleEdit = () => {
    showEditRulesModal({ currentRules: organizationRules });
  };

  return (
    <RulesCard
      rules={organizationRules}
      source="organization"
      onEdit={handleEdit}
      editDisabled={!isAdmin ? 'You are not authorized to edit organization rules' : undefined}
      {...props}
    />
  );
};
